import {
  ADD_EMP_HISTORY_REQUEST,
  ADD_EMP_HISTORY_SUCCESS,
  ADD_EMP_HISTORY_FAIL
} from "../constants/AuthConstant";

const initialState = {
  loading: false,
  result: [],
  msg: "",
  error: "",
};

const AddEmploymentHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_EMP_HISTORY_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case ADD_EMP_HISTORY_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case ADD_EMP_HISTORY_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default AddEmploymentHistoryReducer;
